/**
 * The type of Journey Action Button.
 */
export var JourneyActionButtonType;
(function (JourneyActionButtonType) {
    /**
     * A button that allows the patron to add the journey to their Apple Wallet app.
     */
    JourneyActionButtonType["AppleWallet"] = "AppleWallet";
    /**
     * A button that allows the patron to save the journey to their Google Pay app.
     */
    JourneyActionButtonType["GooglePay"] = "GooglePay";
    /**
     * A button that allows the patron to swap their seats for a completed order.
     */
    JourneyActionButtonType["SwapSeats"] = "SwapSeats";
    /**
     * A custom button.
     */
    JourneyActionButtonType["Custom"] = "Custom";
})(JourneyActionButtonType || (JourneyActionButtonType = {}));
